import { useEffect, useState } from 'react';
import { X, Gift } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = 'essenya_exit_popup_shown';

export default function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    let shown = false;
    const onLeave = (e) => {
      if (shown) return;
      if (e.clientY <= 0) {
        shown = true;
        sessionStorage.setItem(STORAGE_KEY, '1');
        setOpen(true);
      }
    };
    // mobile fallback: show after 25s if not already
    const t = setTimeout(() => {
      if (!shown && !sessionStorage.getItem(STORAGE_KEY)) {
        shown = true;
        sessionStorage.setItem(STORAGE_KEY, '1');
        setOpen(true);
      }
    }, 25000);
    document.addEventListener('mouseout', onLeave);
    return () => { document.removeEventListener('mouseout', onLeave); clearTimeout(t); };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email });
      setSubmitted(true);
    } catch { toast.error('Email non valida'); }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="exit-intent-popup">
      <div className="absolute inset-0 bg-black/55" onClick={() => setOpen(false)} />
      <div className="relative bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-2xl">
        <button onClick={() => setOpen(false)} className="absolute top-4 right-4 z-10" data-testid="exit-popup-close" aria-label="Chiudi"><X size={20} strokeWidth={1.5} /></button>
        <div className="bg-essenya-champagne aspect-[16/9] flex items-center justify-center">
          <Gift size={48} strokeWidth={1.2} className="text-essenya-ink" />
        </div>
        <div className="p-8 text-center">
          {!submitted ? (
            <>
              <div className="text-eyebrow mb-3">Offerta riservata</div>
              <h3 className="font-display text-3xl mb-3">Aspetta. Hai un -10%.</h3>
              <p className="text-essenya-text mb-6">Iscriviti alla newsletter e ricevi subito un codice sconto del 10% sul tuo primo ordine ESSENYA.</p>
              <form onSubmit={submit} className="space-y-3">
                <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="La tua email" data-testid="exit-popup-email" className="w-full bg-white border border-essenya-border rounded-lg px-4 py-3 outline-none focus:border-essenya-ink" />
                <button type="submit" data-testid="exit-popup-submit" className="btn-primary w-full">Riscatta il mio -10%</button>
              </form>
              <button onClick={() => setOpen(false)} className="text-xs text-essenya-text mt-4 underline">No grazie, pago a prezzo pieno</button>
            </>
          ) : (
            <>
              <h3 className="font-display text-3xl mb-3">Fatto!</h3>
              <p className="text-essenya-text mb-4">Usa il codice al checkout:</p>
              <div className="font-display text-2xl bg-essenya-surface2 border border-essenya-border rounded-lg py-3 mb-6 tracking-widest">ESSENYA10</div>
              <button onClick={() => setOpen(false)} className="btn-primary w-full">Inizia lo shopping</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
